__turbopack_context__.v({
  "excludedText": "OuOLsq_excludedText",
  "iconCheck": "OuOLsq_iconCheck",
  "iconContainer": "OuOLsq_iconContainer",
  "iconX": "OuOLsq_iconX",
  "labelContainer": "OuOLsq_labelContainer",
  "toggleButton": "OuOLsq_toggleButton",
  "toggleButtonExcluded": "OuOLsq_toggleButtonExcluded",
});
